// Styles
import styled from 'styled-components/macro'

// Core
import React from 'react'

// Components, services, constants
import Modal from 'components/Modal'
import LinkButton from 'components/LinkButton'
import {SUPPORT_EMAIL, SUPPORT_PHONE} from 'constants/appConstants'
import ClickToCopyIconButton from 'components/ClickToCopyIconButton'

// 3rd party
import classnames from 'classnames'

type Props = {
  className?: string
  open: boolean
  handleClose: () => void
  handleExited: () => void
}

type SupportSectionProps = {
  linkInfo: string
  linkType: string
  title: string
  helperText?: string
}

const modalSections = [
  {
    linkInfo: SUPPORT_PHONE,
    linkType: 'tel:',
    title: 'Support Number',
    helperText: 'Weekdays · 6 a.m. to 6 p.m. PT'
  },
  {
    linkInfo: SUPPORT_EMAIL,
    linkType: 'mailto:',
    title: 'Support Email'
  }
]

const ContactSupportModal = ({className, open, handleClose, handleExited}: Props) => {
  return (
    <ContactSupportModal.Styled
      className={classnames('contact-support-modal', className)}
      size='sm'
      open={open}
      onClose={handleClose}
      onExited={handleExited}
      showCloseButton
    >
      <Modal.Header>
        <h3>Contact Support</h3>
      </Modal.Header>
      <Modal.Content>
        <p>Contact us with any questions or feedback.</p>
        {modalSections.map(section => (
          <ContactSupportModal.SupportSection key={section.title} {...section} />
        ))}
      </Modal.Content>
    </ContactSupportModal.Styled>
  )
}

ContactSupportModal.SupportSection = ({
  linkInfo,
  linkType,
  title,
  helperText
}: SupportSectionProps) => {
  return (
    <section className='contact-section'>
      <div className='contact-section-info'>
        <h6>{title}</h6>
        <p>
          <LinkButton variant='tertiary' href={`${linkType}${linkInfo}`} title={linkInfo} />{' '}
          <span>{helperText}</span>
        </p>
      </div>
      <ClickToCopyIconButton contentToCopy={linkInfo} tooltipTitle='Copy to Clipboard' />
    </section>
  )
}

ContactSupportModal.Styled = styled(Modal)`
  .header {
    padding-bottom: 0;
    h3 {
      margin: 0;
    }
  }
  .content {
    > p {
      color: ${({theme}) => theme.colors.grayscale.gray};
    }
    .contact-section {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 24px;

      .contact-section-info {
        h6 {
          margin: 0 0 4px 0;
        }
        p {
          margin: 0;
          > span {
            color: ${({theme}) => theme.colors.grayscale.gray};
          }
        }
      }

      /* Fixes an IE bug where the IconButton was shifting left when the snackbar was opened */
      .copy-to-clipboard-tooltip {
        margin-left: auto;
      }
    }
  }
  .portal-MuiButton-text {
    transform: translateY(-1px);
  }
`

export default ContactSupportModal
